module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Associate with orders","placeholder":"Choose orders"},"no":{"label":"Koble til oppdrag","placeholder":"Velg oppdrag"}}')
  delete Component.options._Ctor
}
